var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ul", { attrs: { id: "list-tasks" } }, [
    _c("li", [
      _c(
        "div",
        {
          staticStyle: { width: "630px", height: "80px" },
          attrs: { id: "oblea" }
        },
        [
          _c("div", { attrs: { id: "seccion1" } }, [
            _c("p", { attrs: { id: "titulo" } }, [
              _vm._v(_vm._s(_vm.numeroPedido))
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "fv cr",
                staticStyle: {
                  width: "50%",
                  height: "35px",
                  "font-size": "8px",
                  "font-weight": "500",
                  color: "#656E76",
                  "margin-left": "35px",
                  "margin-top": "-7px"
                }
              },
              [
                _c(
                  "div",
                  { staticClass: "fh lb", staticStyle: { height: "50%" } },
                  [
                    _c("div", { staticStyle: { width: "84px" } }, [
                      _vm._v(" Fecha de Alta:")
                    ]),
                    _vm._v(" "),
                    _c("div", [_vm._v(_vm._s(_vm.item.Fecha))])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "fh lc",
                    staticStyle: { height: "50%", "margin-top": "-2px" }
                  },
                  [
                    _c("div", { staticStyle: { width: "84px" } }, [
                      _vm._v(" Fecha de Entrega:")
                    ]),
                    _vm._v(" "),
                    _c("div", [_vm._v(_vm._s(_vm.item.FechaEntrega))])
                  ]
                )
              ]
            ),
            _vm._v(" "),
            _c("span", { staticClass: "label" }, [_vm._v("Items:")]),
            _vm._v(" "),
            _c("span", { staticClass: "value" }, [
              _vm._v(" " + _vm._s(_vm.item.CantidadItems) + " ")
            ]),
            _vm._v(" "),
            _c(
              "span",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.item.Estado != 0,
                    expression: "item.Estado!=0"
                  }
                ],
                staticClass: "label"
              },
              [_vm._v("Precio Total:")]
            ),
            _vm._v(" "),
            _c(
              "span",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.item.Estado != 0,
                    expression: "item.Estado!=0"
                  }
                ],
                staticClass: "value"
              },
              [
                _vm._v(
                  _vm._s(_vm.moneyLabel) +
                    " " +
                    _vm._s(_vm._f("formatMoney")(_vm.montoTotalComp))
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c("div", { attrs: { id: "seccion2" } }, [
            _c("div", { attrs: { id: "seccion3" } }, [
              _c("img", {
                class: {
                  iconVerVisible: _vm.item.Estado != 0,
                  iconVerInvisible: _vm.item.Estado == 0
                },
                attrs: { id: "iconVer", src: "/dist/icon-ver.png" },
                on: { click: _vm.btnVerDetalle }
              }),
              _vm._v(" "),
              _c(
                "span",
                {
                  class: {
                    labelR: _vm.item.Estado != 0,
                    labelRInvisible: _vm.item.Estado == 0
                  },
                  staticStyle: {
                    "margin-right": "10px",
                    "margin-left": "10px"
                  },
                  attrs: { id: "labelVer" },
                  on: { click: _vm.btnVerDetalle }
                },
                [_vm._v(" VER")]
              ),
              _vm._v(" "),
              _c("div", {
                staticStyle: { "margin-left": "40px" },
                attrs: { id: "circulo" + _vm.item.Estado }
              }),
              _vm._v(" "),
              _c("span", { staticClass: "labelR" }, [
                _vm._v(" " + _vm._s(_vm.estado(_vm.item.Estado)) + " ")
              ]),
              _vm._v(" "),
              _c("img", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.item.Estado == 0,
                    expression: "item.Estado==0"
                  }
                ],
                staticStyle: {
                  width: "15px",
                  height: "15px",
                  "margin-left": "22px"
                },
                attrs: {
                  id: "btnEliminarBorrador",
                  src: "/dist/icon-delete.png"
                },
                on: { click: _vm.btnEliminarBorrador }
              })
            ]),
            _vm._v(" "),
            _c("div", { attrs: { id: "seccion4" } }, [
              _c(
                "button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.item.Estado == 0,
                      expression: "item.Estado==0"
                    }
                  ],
                  attrs: { id: "btnIrCarrito" },
                  on: { click: _vm.btnIrCarrito }
                },
                [_vm._v("IR AL CARRITO")]
              )
            ])
          ])
        ]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9611057e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9611057e","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/estadoPedido/itemEstadoPedido.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-9611057e","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/estadoPedido/itemEstadoPedido.vue
// module chunks = 0